import React, { useEffect, Suspense, lazy } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { BurningFacebookBg } from '../components/ui/BurningFacebookBg';
import { StickyFooter } from '../components/ui/StickyFooter';
import { initMetaPixel, trackPixelEvent } from '../hooks/useMetaPixel';
const ProblemSection = lazy(() => import('../components/sections/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('../components/sections/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const AudienceSection = lazy(() => import('../components/sections/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const PricingSection = lazy(() => import('../components/sections/PricingSection').then(m => ({
  default: m.PricingSection
})));
function SectionDivider() {
  return <div className="max-w-3xl mx-auto px-4 md:px-5" data-id="element-343">
      <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent" data-id="element-344" />
    </div>;
}
export function HookArsenalLanding() {
  useEffect(() => {
    document.title = 'Hook Arsenal Viral';
    // Initialize Meta Pixel and fire PageView
    initMetaPixel('935670149636673');
    trackPixelEvent('PageView');
  }, []);
  return <div className="relative min-h-screen w-full bg-bg" data-id="element-345">
      <BurningFacebookBg data-id="element-346" />

      <div className="relative" style={{
      zIndex: 1
    }} data-id="element-347">
        <HeroSection data-id="element-348" />

        <Suspense fallback={null} data-id="element-349">
          <SectionDivider data-id="element-350" />
          <div className="content-auto" data-id="element-351">
            <ProblemSection data-id="element-352" />
          </div>
          <SectionDivider data-id="element-353" />
          <div className="content-auto" data-id="element-354">
            <SolutionSection data-id="element-355" />
          </div>
          <SectionDivider data-id="element-356" />
          <div className="content-auto" data-id="element-357">
            <AudienceSection data-id="element-358" />
          </div>
          <SectionDivider data-id="element-359" />
          <div className="content-auto" data-id="element-360">
            <PricingSection data-id="element-361" />
          </div>
        </Suspense>

        {/* Bottom spacing for sticky footer */}
        <div className="h-28 md:h-24" data-id="element-362" />
      </div>

      <StickyFooter data-id="element-363" />
    </div>;
}